import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcTeam = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 24,
	viewBox: "0 0 29 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.5 8.00391C10.2604 8.00391 11.6875 6.57681 11.6875 4.81641C11.6875 3.056 10.2604 1.62891 8.5 1.62891C6.73959 1.62891 5.3125 3.056 5.3125 4.81641C5.3125 6.57681 6.73959 8.00391 8.5 8.00391ZM1.0625 14.0956C1.0625 11.1224 3.4727 8.71224 6.44583 8.71224H10.5542C13.5273 8.71224 15.9375 11.1224 15.9375 14.0956C15.9375 14.8389 15.3349 15.4414 14.5917 15.4414H2.40833C1.66505 15.4414 1.0625 14.8389 1.0625 14.0956Z",
		fill: "#6C9CFA"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.5 15.0039C22.2604 15.0039 23.6875 13.5768 23.6875 11.8164C23.6875 10.056 22.2604 8.62891 20.5 8.62891C18.7396 8.62891 17.3125 10.056 17.3125 11.8164C17.3125 13.5768 18.7396 15.0039 20.5 15.0039ZM13.0625 21.0956C13.0625 18.1224 15.4727 15.7122 18.4458 15.7122H22.5542C25.5273 15.7122 27.9375 18.1224 27.9375 21.0956C27.9375 21.8389 27.3349 22.4414 26.5917 22.4414H14.4083C13.6651 22.4414 13.0625 21.8389 13.0625 21.0956Z",
		fill: "#8C81F7"
	})]
});
export default SvgIcTeam;
